import { gql } from '@apollo/client'

export const inviteCuratorMutation = gql`
  mutation InviteCuratorMutation($courseId: String!, $userIdOrEmail: String!, $addRemove: AddRemove!) {
    toggleCourseEditor(courseId: $courseId, userIdOrEmail: $userIdOrEmail, addRemove: $addRemove) {
      key
    }
  }
`
